export default "/site/aidive/js/react/dist/images/pao-hero-bg.00f8879e.webp";